<template name="slide">
  <div :class="className">
    <b-media>
      <b-img slot="aside" blank-color="#464646" :src="$root.getProfilePictureUrl(handle)" class="artist-picture"/>
      <ul>
        <li class="name">{{ name }}</li>
        <li v-if="enableInstaLink">
          <a :href="instalLink" target="_blank">@{{ handle }}</a>
        </li>
        <li v-else>@{{ handle }}</li>
        <li v-if="showCounter">
          <b-row class="last-line no-pad">
            <b-col cols="9" class="text-truncate">{{ place }}</b-col>
            <b-col class="text-right counter">
              <span>{{ requests || 0 }}</span>
              <svg svg-inline="" class="icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16"><path fill="#787878" fill-rule="evenodd" d="M12.575 2.047a.507.507 0 0 1 .063.244v7a.502.502 0 0 1-.928.26c-.027-.039-.514-.662-2.327-.662-.89 0-1.533.175-2.278.376-.91.246-1.943.526-3.605.526A5.477 5.477 0 0 1 1 9.204V16H0V.001h1v1.044c.34.238 1.214.746 2.5.746 1.53 0 2.451-.25 3.344-.49.78-.212 1.517-.412 2.54-.412 2.474 0 3.125 1.04 3.191 1.158zM11.638 8.3V2.47c-.179-.165-.775-.58-2.255-.58-.89 0-1.533.175-2.278.376-.91.246-1.943.526-3.605.526A5.51 5.51 0 0 1 1 2.207v5.838c.344.24 1.221.746 2.5.746 1.53 0 2.451-.25 3.344-.49.78-.212 1.517-.412 2.54-.412 1.046 0 1.766.186 2.254.41z"/></svg>
            </b-col>
          </b-row>
        </li>
        <li v-else>{{ place }}</li>
      </ul>
    </b-media>
  </div>
</template>

<script>
export default {
  name: 'Artist',
  props: {
    id: [String, Number],
    name: String,
    handle: String,
    place: String,
    requests: Number,
    showCounter: {
      type: Boolean,
      required: false,
      default: true,
    },
    enableInstaLink: {
      type: Boolean,
      required: false,
      default: false,
    },
    lg: {
      type: Boolean,
    },
  },
  computed: {
    className() {
      return this.lg ? 'large' : '';
    },
    url() {
      return `https://www.instagram.com/${this.instagram}/`;
    },
    instalLink() {
      return `https://www.instagram.com/${this.handle}`;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../assets/css/variables';

  .name {
    color: $yellow;
    font-family: $font-sans-serif-med;
    font-size: $font-size-big;
  }

  li, li * {
    font-size: $font-size-small;

    .counter {
      color: #787878;
    }
  }

  a:hover {
    color: $yellow;
  }

  .media {
    position: relative;
    height: 60px;

    .artist-picture {
      height: 62px;
      width: 62px;
      border-radius: 50%;
    }

    .icon {
      margin-left: 7px;
      margin-top: 0px;
    }

    ul {
      margin: 0;
    }

    div.last-line {
      margin: 0;

      div {
        display: flex;
        padding: 0;

        span {
          margin-left: auto;
        }
      }
    }
  }

  .large {
    .artist-picture {
      width: 72px;
      height: 72px;
    }

    .media-body {
      padding-top: 4px;
    }
  }

  .desktop {
    .large {
      .counter {
        display: none !important;
      }
    }
  }
</style>
